import { SET_LANGUAGE } from "@/constants/mutations-type";
import { LANGUAGE } from "@/constants/storage-type";
import i18n from '@/i18n'
import vuetify from '@/plugins/vuetify'
export default {
  [SET_LANGUAGE]: (state, lang = 'en') => {
    state.lang = lang
    localStorage.setItem(LANGUAGE, lang);
    vuetify.framework.lang.current = lang;
    i18n.locale = lang;
  },
};
